import { styled } from "twin.macro";
import { PageTitle } from "../molecules/PageTitle";

const Dl = styled.div`
  dt {
    font-size: 14px;
    font-weight: 700;
    margin: 0 0 10px;
  }

  dd {
    font-size: 13px;
    line-height: 1.4;
    margin: 0 0 10px;
  }

  dd + dt {
    margin-top: 30px;
  }
`;

export const TermsOfSaleLayout = () => {
  return (
    <>
      <PageTitle title="特定商取引法に基づく表記" />
      <div tw="px-5">
        <Dl>
          <dt>販売事業者名</dt>
          <dd>株式会社ラップス 代表取締役 和田崎達也</dd>
          <dt>運営責任者名</dt>
          <dd>和田崎達也</dd>
          <dt>問い合わせ窓口(メールアドレス)</dt>
          <dd>info@raps.tokyo</dd>
          <dt>本社所在地</dt>
          <dd>東京都渋谷区神宮前3-7-5 青山MSビル6F</dd>
          <dt>お支払い方法</dt>
          <dd>クレジットカードによる決済がご利用頂けます。</dd>
          <dt>代金の支払い時期</dt>
          <dd>注文確定時でお支払いが確定致します。</dd>
          <dt>商品の引渡し時期</dt>
          <dd>入金確認後、お引渡しいたします。</dd>
        </Dl>
      </div>
    </>
  );
};
